



















import {
	computed,
	defineComponent,
	PropType,
	ref,
} from '@vue/composition-api';
import { GroupsStore } from '@front-app/store/singletons/Groups';
import { HighlightsButtonAction, HighlightsButtonComponent, UnfilledHighlightsButtonComponent } from '../../model';
import { BUTTON_BY_ACTION } from './editors/allButtonEditors';
import ActionSelector from './editorSections/ActionSelector.vue';
import { useHighlightsInput } from '../../hooks/useHighlightsInput';
import BaseEditor from '../BaseEditor.vue';

export default defineComponent({
	components: { ActionSelector, BaseEditor },
	props: {
		currentGroupId: {
			type: String,
			required: true,
		},
		value: {
			type: Object as PropType<HighlightsButtonComponent | UnfilledHighlightsButtonComponent>,
			required: true,
		},
	},
	setup(props, ctx) {
		const group = computed(() => GroupsStore.getInstance().groupById(props.currentGroupId));
		const handleInitialActionSelection = (action: null | HighlightsButtonAction) => {
			if (action) {
				const { doMetaInput } = useHighlightsInput(ctx, ref(props.value as HighlightsButtonComponent));
				doMetaInput({ action });
			}
		};
		return {
			handleInitialActionSelection,
			group,
			BUTTON_BY_ACTION,
		};
	},
});
